import React from 'react';

export default function PortalPageHeader({ icon, title, subtitle, badge }) {
  return (
    <div className="flex items-center justify-between gap-3 pl-3 border-l-[3px] border-[#C5A059]">
      <div className="flex items-center gap-2.5 min-w-0">
        {icon && <div className="shrink-0">{icon}</div>}
        <div className="min-w-0">
          <h1 className="text-lg font-extrabold text-[#20243B] leading-tight truncate">{title}</h1>
          {subtitle ? <div className="text-xs text-gray-500 leading-tight mt-0.5">{subtitle}</div> : null}
        </div>
      </div>
      {badge ? (
        <span className="shrink-0 hidden md:inline-flex px-2 py-0.5 rounded bg-[#20243B] text-[9px] font-bold uppercase tracking-wide text-[#C5A059]">{badge}</span>
      ) : null}
    </div>
  );
}
